import { render, staticRenderFns } from "./NavExpandedSection.vue?vue&type=template&id=a22e4874"
import script from "./NavExpandedSection.vue?vue&type=script&lang=js"
export * from "./NavExpandedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationNavExpandedItem: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/navigation/NavExpandedItem.vue').default})
